export class PaginatedResponse {
  totalRecords: number;
  currentPageNumber: number;
  pageSize: number;

  constructor(data: any = {}) {
    this.totalRecords = data.totalRecords || 0;
    this.currentPageNumber = data.currentPageNumber || 0;
    this.pageSize = data.pageSize || 0;
  }
 }



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/paginated-response.ts